import React from "react";
import {genderEnum} from "@/lib/helper/enumType";

function GenderComponent({text, selfMode = false}) {
    if (!text || text === 'none') {
        return <span></span>
    } else {
        return <> <i className={`icon-child ${genderEnum(text, `color`)}`}></i>
            <span className={genderEnum(text, `color`)}>{genderEnum(text, selfMode ? 'selfMode' : null)}</span></>
    }
}

export default GenderComponent